import { render, staticRenderFns } from "./CreateMasjid.vue?vue&type=template&id=dc6fd7f8&scoped=true&"
import script from "./CreateMasjid.vue?vue&type=script&lang=js&"
export * from "./CreateMasjid.vue?vue&type=script&lang=js&"
import style0 from "./CreateMasjid.vue?vue&type=style&index=0&id=dc6fd7f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6fd7f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VFileInput,VFlex,VTextField})
